module.exports = __webpack_public_path__ + "img/Z82_14.481d1171.jpg";